module.exports = __webpack_public_path__ + "media/images/svgs/wave-shape-ae370aeb5e9cbf25ecdb1822575dd342.svg";